var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 5,
    r: 4,
    fill: "#FEEFD7",
    stroke: "#976821"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 19.6667C4 15.9848 6.98477 13 10.6667 13H13.3333C17.0152 13 20 15.9848 20 19.6667C20 21.5076 18.5076 23 16.6667 23H7.33333C5.49238 23 4 21.5076 4 19.6667Z",
    fill: "#FEEFD7",
    stroke: "#976821"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.7a9d6317.svg";
export { ForwardRef as ReactComponent };